import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
import login from "../components/login/login.vue"; //登录
Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "login",
      meta: {
        title: "管理系统",
        /* keepAlive:true*/
      },
      component: () => import("../components/login/login.vue"),
    },
    {
      path: "/",
      redirect: {
        name: "login",
      },
    },
    {
      path: "/homePage",
      name: "homePage",
      component: () => import("../components/homePage/homePage.vue"),
      redirect: {
        name: "statistics",
      },
      children: [
        // {
        //   path: "dashboard",
        //   name: "dashboard",
        //   component: () => import("../view/dashboard/dashboard.vue"),
        // },
        {
          // 可视菜单页面
          path: "/",
          name: "dashboard",
          meta: {
            title: "增值业务管理系统",
          },
          component: () => import("../view/dashboard/dashboard.vue"),
        },
        {
          path: "objUserInfoList", //
          name: "objUserInfoList",
          meta: {
            title: "用户管理",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/userSettings.vue"),
        },
        // 用户管理 产品服务
        {
          path: "objUserProductList",
          name: "objUserProductList",
          meta: {
            title: "产品服务",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/productSettings.vue"),
        },
        {
          path: "sysObjRoleList",
          name: "sysObjRoleList",
          meta: {
            title: "角色管理",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/roleSettings.vue"),
        },
        //机构管理 机构列表
        {
          path: "rmOfficeInfoList",
          name: "rmOfficeInfoList",
          component: () => import("../view/rmOfficeInfo/index.vue"),
        },
        //机构管理 机构列表  创建机构
        {
          path: "createOfficeInfo",
          name: "createOfficeInfo",
          component: () => import("../view/rmOfficeInfo/create.vue"),
        },
        //HR管理 HR列表
        {
          path: "hrInfoList",
          name: "hrInfoList",
          component: () => import("../view/hrInfo/index.vue"),
        },
        // HR管理 HR列表  创建HR
        {
          path: "createHrInfo",
          name: "createHrInfo",
          component: () => import("../view/hrInfo/create.vue"),
        },
        //企业信息管理 企业信息列表
        {
          path: "enterpriseInfoList",
          name: "enterpriseInfoList",
          component: () => import("../view/enterpriseInfoManagement/index.vue"),
        },
        //企业信息管理 企业信息列表  创建企业信息
        {
          path: "createEnterpriseInfo",
          name: "createEnterpriseInfo",
          component: () =>
            import("../view/enterpriseInfoManagement/indexCreate.vue"),
        },
        //企业信息管理 签约管理
        {
          path: "signingManagement",
          name: "signingManagement",
          component: () =>
            import("../view/enterpriseInfoManagement/signContract.vue"),
        },
        //企业信息管理 任务管理
        {
          path: "task",
          name: "task",
          component: () =>
            import("../view/enterpriseInfoManagement/task.vue"),
        },
        //企业信息管理 任务管理  创建任务
        {
          path: "createTask",
          name: "createTask",
          component: () =>
            import("../view/enterpriseInfoManagement/addTask.vue"),
        },
        //企业信息管理 签约管理  创建签约
        {
          path: "createSigningManagement",
          name: "createSigningManagement",
          component: () =>
            import("../view/enterpriseInfoManagement/signContractCreate.vue"),
        },
        // 企业信息管理 配置业务
        {
          path: "enterpriseBusiness",
          name: "enterpriseBusiness",
          component: () =>
            import("../view/enterpriseInfoManagement/business.vue"),
        },
        // 企业信息管理 配置业务  配置产品
        {
          path: "enterpriseProduct",
          name: "enterpriseProduct",
          component: () =>
            import("../view/enterpriseInfoManagement/product.vue"),
        },
        // 企业信息管理 配置政策
        {
          path: "enterprisePolicy",
          name: "enterprisePolicy",
          component: () =>
            import("../view/enterpriseInfoManagement/policy.vue"),
        },
        // 企业信息管理 配置政策  编辑或创建政策
        {
          path: "createEnterprisePolicy",
          name: "createEnterprisePolicy",
          component: () =>
            import("../view/enterpriseInfoManagement/editPolicy.vue"),
        },
        //员工信息管理 员工信息列表
        {
          path: "employeesInfoList",
          name: "employeesInfoList",
          component: () => import("../view/employeesInfoList/index.vue"),
        },
        //员工信息管理 员工信息列表 创建员工信息
        {
          path: "createEmployeesInfo",
          name: "createEmployeesInfo",
          component: () => import("../view/employeesInfoList/indexCreate.vue"),
        },
        //员工信息管理 员工签约列表
        {
          path: "employeesSigningList",
          name: "employeesSigningList",
          component: () => import("../view/employeesInfoList/sign.vue"),
        },
        //员工信息管理 员工签约列表 创建员工签约
        {
          path: "createEmployeesSigning",
          name: "createEmployeesSigning",
          component: () => import("../view/employeesInfoList/signCreate.vue"),
        },
        // 员工信息管理 员工产品服务花名册
        {
          path: "employeesRosterList",
          name: "employeesRosterList",
          component: () => import("../view/employeesInfoList/roster.vue"),
        },
        // 员工信息管理 员工产品服务花名册  创建员工产品服务花名册
        {
          path: "createEmployeesRoster",
          name: "createEmployeesRoster",
          component: () => import("../view/employeesInfoList/editRoster.vue"),
        },
        // 账户中心 企业账户列表
        {
          path: "enterpriseAccountList",
          name: "enterpriseAccountList",
          component: () => import("../view/accountCenter/ent.vue"),
        },
        // 账户中心 企业账户充值
        {
          path: "accountTopUp",
          name: "accountTopUp",
          component: () => import("../view/accountCenter/topUp.vue"),
        },
        // 账户中心 企业账户充值
        {
          path: "accountTopUpDetails",
          name: "accountTopUpDetails",
          component: () => import("../view/accountCenter/topUpDetails.vue"),
        },
        // 账户中心 机构账户列表
        {
          path: "officeAccountList",
          name: "officeAccountList",
          component: () => import("../view/accountCenter/org.vue"),
        },
        // 账户中心 hr账户列表
        {
          path: "hrAccountList",
          name: "hrAccountList",
          component: () => import("../view/accountCenter/hr.vue"),
        },
        // 账户中心 账户明细
        {
          path: "accountDetails",
          name: "accountDetails",
          component: () => import("../view/accountCenter/details.vue"),
        },
        // 账户中心 机构明细
        {
          path: "rmOfficeDetails",
          name: "rmOfficeDetails",
          component: () => import("../view/accountCenter/rmOfficeDetailed.vue"),
        },
        // 账户中心 hr明细
        {
          path: "hrDetails",
          name: "hrDetails",
          component: () => import("../view/accountCenter/hrDetailed.vue"),
        },
        // 账户中心 企业明细
        {
          path: "entDetails",
          name: "entDetails",
          component: () => import("../view/accountCenter/entDetailed.vue"),
        },
        // 调账记录
        {
          path: "accountHistory",
          name: "accountHistory",
          component: () => import("../view/accountHistory/accountHistory.vue"),
        },
        // 业务中心 业务列表
        {
          path: "businessList",
          name: "businessList",
          component: () => import("../view/businessCenter/manage.vue"),
        },
        // 业务中心 业务产品管理
        {
          path: "productList",
          name: "productList",
          component: () => import("../view/businessCenter/product.vue"),
        },
        // 服务中心 工单管理
        {
          path: "workOrderList",
          name: "workOrderList",
          component: () => import("../view/serviceCenter/workOrder.vue"),
        },
        // 服务中心 工单管理  工单详情
        {
          path: "workOrderDetails",
          name: "workOrderDetails",
          component: () => import("../view/serviceCenter/workOrderDetails.vue"),
        },
        // 服务中心 日统计
        {
          path: "dayStatistics",
          name: "dayStatistics",
          component: () => import("../view/serviceCenter/dayStatistics.vue"),
        },
        // 发票中心 发票账户
        {
          path: "invoiceAccount",
          name: "invoiceAccount",
          component: () =>
            import("../view/invoiceCenter/invoiceAccount/invoiceAccount.vue"),
        },

        // 发票调账明细
        {
          path: "invoiceHistory",
          name: "invoiceHistory",
          component: () =>
            import("../view/invoiceCenter/invoiceHistory.vue"),
        },

        // 发票中心 发票账户明细
        {
          path: "invoiceAccountDetail",
          name: "invoiceAccountDetail",
          component: () =>
            import(
              "../view/invoiceCenter/invoiceAccount/invoiceAccountDetail.vue"
            ),
        },
        // 发票中心 发票账户
        {
          path: "invoiceAccount",
          name: "invoiceAccount",
          component: () =>
            import("../view/invoiceCenter/invoiceAccount/invoiceAccount.vue"),
        },
        // 发票中心 发票列表新
        {
          path: "invoiceList",
          name: "invoiceList",
          component: () => import("../view/invoiceCenter/invoiceList.vue"),
        },
        // 发票中心 发票订单  发票详情新
        {
          path: "invoiceListDetails",
          name: "invoiceListDetails",
          component: () =>
            import("../view/invoiceCenter/invoiceListDetails.vue"),
        },
        // 发票中心 发票订单
        {
          path: "invoiceOrder",
          name: "invoiceOrder",
          component: () => import("../view/invoiceCenter/invoiceOrder.vue"),
        },
        // 发票中心 发票订单  发票详情
        {
          path: "invoiceOrderDetails",
          name: "invoiceOrderDetails",
          component: () =>
            import("../view/invoiceCenter/invoiceOrderDetails.vue"),
        },
        // 发票中心 结算订单
        {
          path: "settlementOrder",
          name: "settlementOrder",
          component: () => import("../view/invoiceCenter/settlementOrder.vue"),
        },
        // 订单中心 灵工劳务报酬表
        {
          path: "laborRemuneration",
          name: "laborRemuneration",
          component: () =>
            import("../view/serviceCenter/laborRemuneration.vue"),
        },
        // 订单中心 灵工劳务报酬表  详情
        {
          path: "laborRemunerationDetails",
          name: "laborRemunerationDetails",
          component: () =>
            import("../view/serviceCenter/laborRemunerationDetail.vue"),
        },
        {
          path: "channelConfigList",
          name: "channelConfigList",
          component: () =>
            import("../view/channelAdmin/channelConfigList.vue"),
        },
        {
          path: "addChannelConfig",
          name: "addChannelConfig",
          component: () =>
            import("../view/channelAdmin/addChannelConfig.vue"),
        },
        {
          path: "configList",
          name: "configList",
          component: () =>
            import("../view/channelAdmin/configList.vue"),
        },
        {
          path: "addConfig",
          name: "addConfig",
          component: () =>
            import("../view/channelAdmin/addConfig.vue"),
        },
        {
          path: "dashboard",
          name: "dashboard",
          component: () => import("../view/dashboard/dashboard.vue"),
        },
        {
          path: "taxDetail",
          name: "taxDetail",
          component: () => import("../view/taxDetail/taxDetail.vue"),
        },
        {
          path: "monthTaxList",
          name: "monthTaxList",
          component: () => import("../view/monthTaxList/monthTaxList.vue"),
        },
        {
          path: "proMonthTaxList",
          name: "proMonthTaxList",
          component: () => import("../view/monthTaxList/prMonthTaxList.vue"),
        },
        {
          path: "supplierList",
          name: "supplierList",
          component: () => import("../view/supplier/supplier.vue"),
        },
        {
          path: "supBusinessCfg",
          name: "supBusinessCfg",
          meta: {
            title: "供应商业务配置",
          },
          component: () => import("../view/supplier/supBusinessCfg.vue"),
        },
        {
          path: "addSupplier",
          name: "addSupplier",
          component: () => import("../view/supplier/addSupplier.vue"),
        },
        {
          path: "supplierBusinessList",
          name: "supplierBusinessList",
          component: () => import("../view/supplier/businessList.vue"),
        },
        {
          path: "openProduct",
          name: "openProduct",
          component: () => import("../view/supplier/openProduct.vue"),
        },
        // 福利
        {
          path: "welfareList",
          name: "welfareList",
          component: () => import("../view/welfare/welfareList.vue"),
        }
      ],
    },
  ],
});

//全局路由守卫
router.beforeEach((to, from, next) => {
  /*路由发生变化修改页面title*/
  if (to.meta.title) {
    document.title = "管理系统";
    // 获取 JWT Token
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js